import { __awaiter, __generator } from "tslib";
import { w } from '@tinkoff/statist-page-data';
import { validateSharedParameters, validateVersion } from './utils';
var AndroidBridge = /** @class */ (function () {
    function AndroidBridge() {
    }
    AndroidBridge.prototype.isConnected = function () {
        return w._statistAndroidSdkBridge !== undefined;
    };
    AndroidBridge.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (!validateVersion((_a = w._statistAndroidSdkBridge) === null || _a === void 0 ? void 0 : _a.getVersion())) {
                    throw new Error('Unsupported version of bridge');
                }
                return [2 /*return*/];
            });
        });
    };
    AndroidBridge.prototype.parseSharedParameters = function (sharedParametersJson) {
        try {
            var parsed = JSON.parse(sharedParametersJson);
            if (validateSharedParameters(parsed)) {
                return parsed;
            }
            return null;
        }
        catch (_a) {
            return null;
        }
    };
    AndroidBridge.prototype.getSharedParameters = function () {
        var _a;
        var sessionString = (_a = w._statistAndroidSdkBridge) === null || _a === void 0 ? void 0 : _a.getSharedParameters();
        if (!sessionString) {
            return null;
        }
        return this.parseSharedParameters(sessionString);
    };
    AndroidBridge.prototype.getApiKey = function () {
        var _a;
        var apiKeyString = (_a = w._statistAndroidSdkBridge) === null || _a === void 0 ? void 0 : _a.getApiKey();
        if (!apiKeyString || typeof apiKeyString !== 'string') {
            return null;
        }
        return apiKeyString;
    };
    AndroidBridge.prototype.notifyEventHappened = function () {
        var _a;
        (_a = w._statistAndroidSdkBridge) === null || _a === void 0 ? void 0 : _a.notifyEventHappened();
    };
    return AndroidBridge;
}());
export { AndroidBridge };
//# sourceMappingURL=android-bridge.js.map